export default __webpack_public_path__ + "static/media/ads-web-3.3dea2f3f.gif";